module.exports = __webpack_public_path__ + "static/media/majorD1.8dccf66.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD1.wav
// module id = byR7
// module chunks = 0